export default {
    conflicts(val){
        console.log('transformer-conflicts',val)

        let ret = []

        Object.keys(val).forEach(item => {
            ret.push({
                remote: item,
                local: val[item]
            })
        })

        return ret
    }
}


// WEBPACK FOOTER //
// ./src/services/transformers.js